export default __webpack_public_path__ + "static/media/bag13.94c0eb3a.jfif";